import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaDownload, FaFilter } from "react-icons/fa";

const API_URL = "https://backend.aktcorp.com/relateddocuments";

const RelatedDocuments = () => {
  const [allDocuments, setAllDocuments] = useState([]);
  const [visibleDocuments, setVisibleDocuments] = useState(6);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedDocumentType, setSelectedDocumentType] = useState("");

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await axios.get(API_URL);
        setAllDocuments(response.data.data);
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };

    fetchDocuments();
  }, []);

  const filteredDocuments = allDocuments.filter(
    (doc) =>
      (selectedLanguage ? doc.language === selectedLanguage : true) &&
      (selectedDocumentType ? doc.category === selectedDocumentType : true)
  );

  const displayedDocuments = filteredDocuments.slice(0, visibleDocuments);

  const loadMoreOrLess = () => {
    if (visibleDocuments >= filteredDocuments.length) {
      setVisibleDocuments(6);
    } else {
      setVisibleDocuments(filteredDocuments.length);
    }
  };

  const handleDownload = (doc) => {
    const viewerUrl = `/view-pdf-doc/${doc.id}?title=${encodeURIComponent(doc.title)}`;
    window.open(viewerUrl, "_blank");
  };

  const clearFilters = () => {
    setSelectedLanguage("");
    setSelectedDocumentType("");
  };

  const languages = [...new Set(allDocuments.map((doc) => doc.language))];
  const documentTypes = [...new Set(allDocuments.map((doc) => doc.category))];

  return (
    <div className="m-4 p-6 bg-white rounded-xl shadow-md">
      <h2 className="text-3xl font-extrabold mb-6 text-[#0C2340] border-b-4 border-red-600 pb-3">
        Related Documents
      </h2>

      {/* Filters */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="relative w-full md:w-1/3">
          <select
            value={selectedLanguage}
            onChange={(e) => setSelectedLanguage(e.target.value)}
            className="w-full p-3 border rounded-md text-sm shadow-sm"
          >
            <option value="">Filter by Language</option>
            {languages.map((lang) => (
              <option key={lang} value={lang}>
                {lang}
              </option>
            ))}
          </select>
          <FaFilter className="absolute right-4 top-4 text-gray-500" />
        </div>

        <div className="relative w-full md:w-1/3">
          <select
            value={selectedDocumentType}
            onChange={(e) => setSelectedDocumentType(e.target.value)}
            className="w-full p-3 border rounded-md text-sm shadow-sm"
          >
            <option value="">Filter by Document Type</option>
            {documentTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
          <FaFilter className="absolute right-4 top-4 text-gray-500" />
        </div>

        <button
          onClick={clearFilters}
          className="px-4 py-3 bg-gray-100 hover:bg-gray-200 text-sm rounded-md font-medium transition"
        >
          Clear Filters
        </button>
      </div>

      {/* Document List */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {displayedDocuments.map((doc) => (
          <div
            key={doc.id}
            className="flex justify-between items-center p-4 border rounded-lg hover:bg-gray-50 transition"
          >
            <div className="flex items-start gap-4">
              <div>
                <p className="font-semibold text-[#0C2340] text-sm md:text-base">
                  {doc.title}
                </p>
                <div className="flex gap-2 mt-2 flex-wrap">
                  <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                    {doc.category}
                  </span>
                  <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                    {doc.language}
                  </span>
                </div>
              </div>
            </div>

            <button
              onClick={() => handleDownload(doc)}
              className="text-[#0C2340] hover:bg-gray-200 p-2 rounded-full"
            >
              <FaDownload className="text-xl" />
            </button>
          </div>
        ))}
      </div>

      {/* Show More / Less */}
      {filteredDocuments.length > 6 && (
        <div className="text-center mt-8">
          <button
            onClick={loadMoreOrLess}
            className="px-6 py-2 bg-[#0C2340] text-white rounded-md hover:bg-[#1B365D] transition text-sm font-medium"
          >
            {visibleDocuments >= filteredDocuments.length ? "Show Less" : "Show More"}
          </button>
        </div>
      )}
    </div>
  );
};

export default RelatedDocuments;
